import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/sign-in")({
	component: () => (
		<main className="flex min-h-screen items-center justify-center">
			<Outlet />
		</main>
	),
})
